import React, { useState } from "react";
import { PageTopbar } from "../components/Page/Topbar";
import { Message } from "../components/Message";
import { AppHome } from "../app/Home";
import { useLocation } from "react-router-dom";

export function RoutesHome({ parents = "/", current }) {

    const location = useLocation();
    const {message} = useState((location.state !== null 
        ? location.state.message 
        : null));
    const {messageType} = useState((location.state !== null 
        ? location.state.type 
        : null));

    return (
        <div>
            <PageTopbar 
                parents={parents}
                current={current}
            />
            <Message type={messageType} message={message} />
            <AppHome />
        </div>
    );
}